import { render, staticRenderFns } from "./TraxAccountUserEdit.vue?vue&type=template&id=4e6cd818"
import script from "./TraxAccountUserEdit.vue?vue&type=script&lang=js"
export * from "./TraxAccountUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports